import { render, staticRenderFns } from "./ErpIntegracoes.vue?vue&type=template&id=4fe6baa4&scoped=true&"
import script from "./ErpIntegracoes.vue?vue&type=script&lang=js&"
export * from "./ErpIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./ErpIntegracoes.vue?vue&type=style&index=0&id=4fe6baa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6baa4",
  null
  
)

export default component.exports